import React from 'react';

import StationRingsIcon from '../../../../../static/icons/station_rings.svg';
import Icon from '../../../Icon/Icon';

import './RowItemRings.scss';

const RowItemRings = React.memo(() => {
  return (
    <div className='RowItemRings'>
      <Icon className='stationRings' glyph={StationRingsIcon} />
    </div>
  );
});

export default RowItemRings;
